import { ArrowLeftIcon, RectangleStackIcon } from "@heroicons/react/24/outline";
import React, { useState } from "react";

export const MultiSSOLogin = ({ workspace, sso = [], onSSOSelect, onBack, showBackButton = true, renderPasswordOption = () => {} }) => {
  const [loadingId, setLoadingId] = useState(null);

  const handleSSOClick = async (ssoProvider) => {
    setLoadingId(ssoProvider._id);
    await new Promise((resolve) => setTimeout(resolve, 500));
    onSSOSelect?.(ssoProvider);
  };

  const getProviderStyle = () => {
    return {
      className: `
        w-full flex items-center justify-between rounded-lg border border-gray-300 bg-white px-4 py-3 
        text-sm font-medium text-gray-900 shadow-sm transition-all duration-200 
        hover:bg-gray-50 hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 
        disabled:opacity-50 disabled:cursor-not-allowed
      `,
      style: {},
    };
  };

  if (!sso || sso.length === 0) {
    return (
      <div className="mx-auto w-full max-w-md p-4 sm:p-6">
        <div className="mb-6 text-center">
          {workspace && (
            <div className="mb-3 flex items-center justify-center">
              <div className="mr-3 flex h-10 w-10 items-center justify-center overflow-hidden rounded-lg bg-gray-100">
                {workspace.square_logo || workspace.image_favicon || workspace.image_logo ? (
                  <img
                    src={workspace.square_logo || workspace.image_favicon || workspace.image_logo}
                    alt={workspace.name}
                    className="h-full w-full object-cover"
                  />
                ) : (
                  <RectangleStackIcon className="h-6 w-6 text-gray-400" />
                )}
              </div>
              <h2 className="text-lg font-semibold text-gray-900">{workspace.name}</h2>
            </div>
          )}
        </div>
        {renderPasswordOption({ showPasswordField: true, showOrOption: false, workspace })}
        {showBackButton && onBack && (
          <div className="mt-6 text-center">
            <button
              type="button"
              onClick={onBack}
              className="inline-flex items-center text-sm text-gray-500 transition-colors duration-200 hover:text-gray-700">
              <ArrowLeftIcon className="mr-1 h-4 w-4" />
              Back to workspaces
            </button>
          </div>
        )}
      </div>
    );
  }
  return (
    <div className="mx-auto w-full max-w-md p-4 sm:p-6">
      <div className="mb-6 text-center">
        {workspace && (
          <div className="mb-3 flex items-center justify-center">
            <div className="mr-3 flex h-10 w-10 items-center justify-center overflow-hidden rounded-lg bg-gray-100">
              {workspace.square_logo || workspace.image_favicon || workspace.image_logo ? (
                <img
                  src={workspace.square_logo || workspace.image_favicon || workspace.image_logo}
                  alt={workspace.name}
                  className="h-full w-full object-cover"
                />
              ) : (
                <RectangleStackIcon className="h-6 w-6 text-gray-400" />
              )}
            </div>
            <h2 className="text-lg font-semibold text-gray-900">{workspace.name}</h2>
          </div>
        )}
        <p className="text-sm text-gray-500">Choose your organization's SSO provider</p>
      </div>

      <div className="space-y-3">
        {sso.map((provider) => {
          const style = getProviderStyle(provider);
          const isLoading = loadingId === provider._id;

          return (
            <button
              key={provider._id}
              type="button"
              className={style.className}
              style={style.style}
              onClick={() => handleSSOClick(provider)}
              disabled={isLoading}
              data-provider={provider.provider_name}
              aria-label={`Sign in with ${provider.provider_name}`}>
              <span className="flex-1 truncate text-left">Sign in with {provider.provider_name}</span>
              <span className="ml-2 inline-flex items-center text-xs text-gray-500">{isLoading ? "Redirecting…" : "→"}</span>
            </button>
          );
        })}
      </div>
      {workspace?.dual_signin_for_user && renderPasswordOption({ showPasswordField: true, workspace })}
      {showBackButton && onBack && (
        <div className="mt-6 text-center">
          <button
            type="button"
            onClick={onBack}
            className="inline-flex items-center text-sm text-gray-500 transition-colors duration-200 hover:text-gray-700">
            <ArrowLeftIcon className="mr-1 h-4 w-4" />
            Back to workspaces
          </button>
        </div>
      )}
    </div>
  );
};
